import { createAction, props } from '@ngrx/store'

export const loading = createAction(
    '[Loading] Loading Data',
    props<{ item: any }>()

)